import { TILES, type Material, type TileId } from "@dyson/shared";

/** What a block sounds like (see BlockSpec.sound). */
export function materialOf(t: TileId): Material {
  return TILES[t]?.sound ?? "rock";
}

/** The sound name for `kind` of thing happening to `material`, e.g. "digWood". */
export function materialSound<K extends "dig" | "place" | "step">(kind: K, material: Material): `${K}${Capitalize<Material>}` {
  return `${kind}${material[0]!.toUpperCase()}${material.slice(1)}` as `${K}${Capitalize<Material>}`;
}
